import styles from "./style.module.css"
import newIcon from "../../assets/icons/new.svg"
import { useNavigate } from "react-router-dom"
const NinPortal = () => {
    const navigate = useNavigate()
    return (
       <div className={styles.ninPortalContainer}>
<h1>Welcome to the 
NIN Collection Portal</h1>
<p>Lets get started...</p>
<button onClick={() => navigate("/nin-open-account")}>
<img src={newIcon} alt="new-icon" />
Proceed to link your NIN to your account
</button>
       </div>

    )
}

export default NinPortal;